import React, { lazy, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import { GodModeAuthProvider } from '../contexts/GodModeAuthContext';
import { GodModeProtectedRoute } from './GodModeProtectedRoute';
import { GodModeLayout } from './GodModeLayout';
import { Loader2 } from 'lucide-react';

// Lazy load das páginas God Mode
const GodModeAuthPage = lazy(() => import('../pages/GodModeAuthPage').then(m => ({ default: m.GodModeAuthPage })));
const GodModeDashboard = lazy(() => import('../pages/GodModeDashboard').then(m => ({ default: m.GodModeDashboard })));
const GodModeAuditLogs = lazy(() => import('../pages/GodModeAuditLogs').then(m => ({ default: m.GodModeAuditLogs })));
const GodModeTenants = lazy(() => import('../pages/GodModeTenants').then(m => ({ default: m.GodModeTenants })));
const GodModeAICredits = lazy(() => import('../pages/GodModeAICredits').then(m => ({ default: m.GodModeAICredits })));
const GodModeSettings = lazy(() => import('../pages/GodModeSettings').then(m => ({ default: m.GodModeSettings })));
const GodModeUsers = lazy(() => import('../pages/GodModeUsers').then(m => ({ default: m.GodModeUsers })));
const GodModeTestUsers = lazy(() => import('../pages/GodModeTestUsers').then(m => ({ default: m.GodModeTestUsers })));
const GodModeSecrets = lazy(() => import('../pages/GodModeSecrets').then(m => ({ default: m.GodModeSecrets })));

const PageLoader = () => (
  <div className="flex items-center justify-center min-h-screen bg-slate-950">
    <Loader2 className="w-8 h-8 animate-spin text-cyan-500" />
  </div>
);

export const GodModeRoutes: React.FC = () => {
  return (
    <GodModeAuthProvider>
      <Suspense fallback={<PageLoader />}>
        <Routes>
          <Route path="auth" element={<GodModeAuthPage />} />
          <Route element={
            <GodModeProtectedRoute>
              <GodModeLayout />
            </GodModeProtectedRoute>
          }>
            <Route path="dashboard" element={<GodModeDashboard />} />
            <Route path="tenants" element={<GodModeTenants />} />
            <Route path="settings" element={<GodModeSettings />} />
            <Route path="ai-credits" element={<GodModeAICredits />} />
            <Route path="users" element={<GodModeUsers />} />
            <Route path="test-users" element={<GodModeTestUsers />} />
            <Route path="secrets" element={<GodModeSecrets />} />
            <Route path="audit" element={<GodModeAuditLogs />} />
          </Route>
        </Routes>
      </Suspense>
    </GodModeAuthProvider>
  );
};
